import * as api from "./api";
import { useUserSessionStore } from "stores/v2/userSessionStore";
import * as clsApi from "./classroomApi";
import { UserDetail } from "stores/classroomStore_I";
import { UserInfo } from "./authApi";

export async function getUsers(options: object | undefined): Promise<unknown> {
	// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
	const res: { result: unknown } = await api.get("/backend/all/users", options);
	return res.result;
}

export async function getRestrictedUsers(options: object | undefined): Promise<unknown> {
	// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
	const res: { result: unknown } = await api.get("/backend/all/restricted_users", options);
	return res.result;
}

export async function getClassroomUsers(classroomId: string, options: object | undefined): Promise<unknown> {
	// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
	const res: { result: unknown } = await api.post("/backend/classroom/users", { name: classroomId }, options);
	return res.result;
}

export async function searchUsers(filterStr: string): Promise<UserInfo[]> {
	let userStableIDv1 = useUserSessionStore.getState().getTeacherId();

	// This won't ever happen while the user is logged in, this is just to make TS happy
	if (userStableIDv1 === undefined) {
		userStableIDv1 = "";
	}

	const endpoint = `users/search?q=${encodeURIComponent(filterStr)}&userStableIDv1=${userStableIDv1}`;
	return await clsApi.Get(endpoint);
}

export async function getUserDetail(
	userName: string,
	includeGroups: boolean,
	includeClassrooms: boolean,
	includeRestrictedCheck: boolean
): Promise<UserDetail | undefined> {
	return await clsApi.Get(
		`users/${encodeURIComponent(
			userName
		)}?includeGroups=${includeGroups.toString()}&includeClassrooms=${includeClassrooms.toString()}&includeRestrictedCheck=${includeRestrictedCheck.toString()}`
	);
}
